// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"faqmain_wrapper__rwL10","headline":"faqmain_headline__JE6na"};